import React from "react";
import TimeAgo from "timeago-react";
import * as timeago from "timeago.js";
import moment from "moment-timezone";
import ko from "timeago.js/lib/lang/ko";
import my from "timeago.js/lib/lang/my";
import vi from "timeago.js/lib/lang/vi";
import ja from "timeago.js/lib/lang/ja";
import th from "timeago.js/lib/lang/th";
import zh_CN from "timeago.js/lib/lang/zh_CN";
import id from "timeago.js/lib/lang/id_ID";

timeago.register("vi", vi);
timeago.register("ko", ko);
timeago.register("my", my);
timeago.register("ja", ja);
timeago.register("th", th);
timeago.register("zh_CN", zh_CN);
timeago.register("id", id);

// Hàm lấy timezone theo ngôn ngữ
const getTimeZoneName = (locale: string) => {
  switch (locale) {
    case "vi":
      return "Asia/Ho_Chi_Minh";
    case "ko":
      return "Asia/Seoul";
    case "my":
      return "Asia/Yangon";
    case "en":
      return "UTC";
    case "zh":
      return "Asia/Shanghai";
    case "ja":
      return "Asia/Tokyo";
    case "th":
      return "Asia/Bangkok";
    case "id":
      return "Asia/Jakarta";
    default:
      return "Asia/Ho_Chi_Minh";
  }
};

// Component sử dụng formatter
const NumericTimeAgoWithUnit = ({
  createdAt,
  locale,
}: {
  createdAt: string | Date;
  locale: "vi" | "my" | "en" | "ko" | "zh" | "ja" | "th" | "id";
  shortTime?: boolean;
}) => {

  const localizedTime = moment
    .tz(createdAt, "UTC")
    .tz(getTimeZoneName(locale))
    .toDate();
  const now = moment();
  const pastTime = moment(localizedTime);
  const diffInHours = now.diff(pastTime, "hours");

  return (
    <>
      {diffInHours >= 24 ? (
        pastTime.format("DD-MM-YYYY HH:mm")
      ) : (
        <TimeAgo datetime={localizedTime} locale={locale} />
      )}
    </>
  );
};

export default NumericTimeAgoWithUnit;
